<template>
    <div class="qr-scanner">
      <div class="camera-view">
        <video ref="video" autoplay playsinline></video>
      </div>
      <canvas ref="canvas" class="hidden"></canvas>
      <div v-if="scannedData" class="scanned-data">
        <p>Scanned Data: {{ scannedData }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import jsQR from "jsqr";
  
  export default {
    data() {
      return {
        scannedData: null,
        videoStream: null,
      };
    },
    methods: {
      async startScanner() {
        try {
          // Request access to the camera
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "environment" },
          });
          this.videoStream = stream;
  
          const video = this.$refs.video;
          video.srcObject = stream;
  
          video.addEventListener("loadedmetadata", () => {
            video.play();
            this.scanQRCode();
          });
        } catch (error) {
          console.error("Camera access denied:", error);
        }
      },
      async scanQRCode() {
        const canvas = this.$refs.canvas;
        const video = this.$refs.video;
  
        const context = canvas.getContext("2d");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
  
        const scan = () => {
          if (video.readyState === video.HAVE_ENOUGH_DATA) {
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            const code = jsQR(imageData.data, canvas.width, canvas.height);
  

            if (code) {
              this.scannedData = code.data;
              console.log("Scanned Data:", this.scannedData);
              this.$router.push({ name: "QRredirectPage", query: {data: encodeURIComponent(this.scannedData)} , params: { target: this.scannedData } });

              this.stopScanner(); // Stop after detecting the code
            } else {
              requestAnimationFrame(scan);
            }
          } else {
            requestAnimationFrame(scan);
          }
        };
  
        scan();
      },
      stopScanner() {
        // Stop the camera stream
        if (this.videoStream) {
          this.videoStream.getTracks().forEach((track) => track.stop());
        }
        this.videoStream = null;
      },
    },
    mounted() {
      this.startScanner();
    },
    beforeUnmount() {
      this.stopScanner();
    },
  };
  </script>
  
  <style scoped>
  .qr-scanner {
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000;
  }
  
  .camera-view video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .hidden {
    display: none;
  }
  
  .scanned-data {
    position: absolute;
    bottom: 10%;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
  }
  </style>
  